import { makeFontToken, makeLengthToken } from '@utils/css';

const proxima = makeFontToken("--proxima", {
  fontFaces: {
    light: ["proxima-nova", 300],
    default: ["proxima-nova", 400],
    medium: ["proxima-nova", 600],
    bold: ["proxima-nova", 700],
    ["extra-bold"]: ["proxima-nova", 800]
  },
  default: "default"
});
const dyslexie = makeFontToken("--dyslexie", {
  fontFaces: {
    light: ["dyslexie", 400],
    default: ["dyslexie", 400],
    medium: ["dyslexie", 700],
    bold: ["dyslexie", 700],
    "extra-bold": ["dyslexie", 700]
  },
  default: "default"
});
const body = proxima.__extend("--body-font");
const lineHeightScales = {
  proxima: 1,
  dyslexie: 1.41666667
};
const fontScales = {
  proxima: 1,
  dyslexie: 0.88889
};
const fonts = {
  lineHeight: makeLengthToken("--line--height", "1"),
  proxima,
  dyslexie,
  body
};

export { fontScales, fonts, lineHeightScales };
//# sourceMappingURL=fonts.js.map
